// @flow strict

import type {AgentApiParams} from 'src/types/scheduler/global.js';
import type {SchedulerGlobalActions} from 'src/action-creators/scheduler/global.js';

import {SET_AGENT_API_PARAMS} from 'src/action-creators/scheduler/global.js';


export type SchedulerGlobalState = {
  agentApiParams: AgentApiParams,
};

export const initialState: SchedulerGlobalState = {
  agentApiParams: {
    actor: 'self',
    agentId: '',
  },
};

export default function schedulerGlobal(
  state: SchedulerGlobalState = initialState,
  action: SchedulerGlobalActions,
): SchedulerGlobalState {
  switch (action.type) {
    case SET_AGENT_API_PARAMS:
      return {
        ...state,
        agentApiParams: action.payload,
      };
    default:
      return state;
  }
}
